<script setup lang="ts">
import type { KanbanTimeOffBooking } from '../../model/interfaces'

import { AppText } from '@shared/ui/typography'
import { LinkTextPrimaryMedium } from '@shared/ui/links'

import { useTimeOffBooking } from '../../model/time-off-booking.hook'

defineOptions({
  name: 'TimeOffBooking',
})

const props = defineProps<{
  booking: KanbanTimeOffBooking
}>()

const {
  refDate,
  refDiscipline,
  refGrade,
  refDisciplineHref,
} = useTimeOffBooking({ booking: computed(() => props.booking) })
</script>

<template>
  <AppText
    name="body1"
    class="time-off-booking"
    color="slate-900"
  >
    <span>{{ refDate }} -</span>
    <span>{{ booking.kid.name }}</span>
    <LinkTextPrimaryMedium
      :href="refDisciplineHref"
      target="_blank"
      color="blue"
    >
      {{ refDiscipline }}
    </LinkTextPrimaryMedium>
    <span class="time-off-booking__grade">{{ refGrade }}</span>
  </AppText>
</template>

<style scoped lang="scss" src="./TimeOffBooking.scss" />
